import { useState, useEffect } from "react";
import { Tabbar, Notify, Cell, Loading, Tour, Dialog, Input, Avatar, Animate, Progress, Toast, NoticeBar } from '@nutui/nutui-react';
import { Setting as SettingIcon, Agenda as AgendaIcon, User as UserIcon, Lock, Unlock, Eye, Marshalling } from '@nutui/icons-react'
import Home from './pages/Home'
import Setting from './pages/Setting'
import Book from './pages/Book'
import NotFound from "./pages/NotFound";
import Init from "./pages/Init";
import axios from "axios";
import dayjs from 'dayjs';
import { refreshPageWithTimestamp } from './common';

import 阿咸 from './img/阿咸/1.png'

let pathname = window.location.pathname

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(`${pathname}:token`);
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    const Authorization = response.headers.getAuthorization()
    Authorization && localStorage.setItem(`${pathname}:token`, Authorization)
    return response
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);


function App() {

  const [users, setUsers] = useState([])
  const [currentUser, setCurrentUser] = useState(null)
  const [page, setPage] = useState(-10);
  const [loginType, setLoginType] = useState(0) // 0: 初始值；1：未绑定；2：已登录未选服；3：已选服
  const [serverList, setServerList] = useState(null)

  const [showTour, setShowTour] = useState(false)
  const [password, setPassword] = useState('')
  const [dialogStatus, setDialogStatus] = useState({
    show: false,
  })

  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    content: <div></div>,
    hideConfirmButton: true,
    hideCancelButton: false,
    onCancel: null,
    onConfirm: () => { }
  })
  const [formValues, setFormValues] = useState(null)
  const [loading, setLoading] = useState(false)

  const [inputType, setInputType] = useState('password')
  const [percent, setPercent] = useState(0)
  const [notice, setNotice] = useState(null)

  const closeTour = () => {
    setShowTour(false)
  }



  const steps = [
    {
      content: '点击此处修改密码',
      target: 'lock',
      // popoverOffset: [-50, 50],
      // arrowOffset: 0,
    },
  ]

  useEffect(() => {
    // let pathname = window.location.pathname
    setLoading(true)
    axios.get(`/v1/login${pathname}`).then(({ data }) => {
      setLoading(false)

      if (data.code === 405) {
        setPage(-3)
        return
      }

      if (!data.code || data.code === 400) {
        setPage(-2)
      } else {
        const { token } = data
        if (token) {
          localStorage.setItem(`${pathname}:token`, token)
        }

        getUser()
      }
    }).catch(err => {
      setLoading(false)
    })
  }, [])


  const getUser = () => {
    setLoading(true)
    axios.get("/v1/getUser").then(({ data }) => {
      setLoading(false)
      if (data.code === 201) {
        if (data.body.type === "expire") {
          Notify.warn(data.msg)
          return
        }
        if (data.body.type === "waiting") {
          setPercent(50)
          const id = setInterval(() => {
            setPercent(percent + 1)
            if (percent >= 100) {
              setPercent(99)
              clearInterval(id)
            }
            setPercent(percent + 2)
          }, 1000);
          setTimeout(() => {
            refreshPageWithTimestamp();
          }, 5000)
          return
        }
        setDialogStatus({ show: true, type: data.body.type })
        return
      }

      if (data.code === 200) {
        const { body } = data
        setUsers(body.users)
        body.notice && setNotice(body.notice)
        // if (type && body.users.length === 1) {
        //   setShowTour(true)
        // }
        if (body.users.length === 0) {
          setLoginType(1)
          setPage(-1)
        } else {
          if (body.users[0].login_type === 2) {
            setCurrentUser(body.users[0])
            setLoginType(2)
            setPage(-1)
            axios.post("/v1/getServerList", { encryptUser: body.users[0].encrypt_user }).then(({ data }) => {
              if (data.code === 400) {
                Dialog.alert({
                  title: '警告',
                  content: data.msg,
                  hideCancelButton: true,
                  confirmText: '确认',
                  closeOnOverlayClick: false
                })
                return
              }
              const { body } = data
              setServerList(body)
            })
          } else if (!body.users[0].role_info || Object.keys(body.users[0].role_info).length === 0) {
            setPage(-4)
            return
          } else {

            if (body.users[0]["unlock_time"] && dayjs().isBefore(dayjs.unix(body.users[0]["unlock_time"]))) {
              let errMsg
              if (body.users[0]["lock_info"].includes("封禁")) {
                errMsg = `检测到您的账号被封禁, 解封时间 ${dayjs.unix(body.users[0]["unlock_time"]).format("YYYY-MM-DD HH:mm:ss")}, 解封之后再使用`
              } else if (body.users[0]["lock_info"].includes("账号保护")) {
                errMsg = `检测到您的账号被临时保护, 解封时间 ${dayjs.unix(body.users[0]["unlock_time"]).format("YYYY-MM-DD HH:mm:ss")}, 解封之后再使用`
              }

              Dialog.alert({
                content: errMsg,
                confirmText: '确认',
                // cancelText: '取消',
                lockScroll: false,
                hideCancelButton: true,
                closeOnOverlayClick: true
              })
              return
            }

            let type = body.users[0].login_type
            setCurrentUser(body.users[0])
            setLoginType(type)
            setPage(1)
          }


        }

      } else {
        Notify.warn(data.msg || "获取用户信息失败")
      }
    }).catch(err => {
      Notify.warn(err)
      setLoading(false)
    })
  }

  const configPassword = type => {
    setLoading(true)
    if (type === "validate") {

      axios.post('/v1/validatePassword', { password }).then(({ data }) => {
        setLoading(false)
        if (data.code === 200) {
          // Notify.success("密码设置成功")
          refreshPageWithTimestamp();
          setPassword("")
          setDialogStatus({ show: false })
        } else {

          Toast.show({
            content: '验证失败',
            icon: 'fail',
          })
          // Notify.warn("验证失败")
        }
      }).finally(() => {
        setLoading(false)
      })
      return
    }
    if (type === "init") {
      axios.post('/v1/initPassword', { password }).then(({ data }) => {
        setLoading(false)
        if (data.code === 200) {
          // Notify.success("密码设置成功")
          refreshPageWithTimestamp();
          // getUser("init")
          setPassword("")
          setDialogStatus({ show: false })
        } else {
          Toast.show({
            content: '设置失败',
            icon: 'fail',
          })
          // Notify.warn("设置失败")
        }
      }).finally(() => {
        setLoading(false)
      })
      return
    }

    axios.post('/v1/updatePassword', { password }).then(({ data }) => {
      setLoading(false)
      if (data.code === 200) {
        Notify.success("密码设置成功")
        // type === "init" && window.location.reload()
        setPassword("")
        setDialogStatus({ show: false })
      } else {
        Notify.warn("密码设置失败, 请刷新重试")
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const updateConfig = (formValues, callback) => {
    setLoading(true)

    axios.post('/v1/updateConfig', { config: formValues, encryptUser: currentUser.encrypt_user }).then(({ data }) => {
      setLoading(false)
      if (data.code === 400) {
        Notify.warn("修改失败, 请重试", { duration: 1000 })
      }
      if (data.code === 200) {
        currentUser.config = formValues
        users.forEach(user => {
          if (user.encryptUser === currentUser.encryptUser) {
            user.config = formValues
          }
        })
        setUsers([...users])
        setCurrentUser({ ...currentUser })
        Notify.success("成功", { duration: 1000 })
        setFormValues(null)
        callback && callback()
      }

    }).finally(() => {
      setLoading(false)
    })
    // console.log(formValues)


  }

  const onConfigChangeCb = formValues => {
    setFormValues(formValues)
  }

  const onCancelConfirmDialog = () => setConfirmDialog({
    show: false
  })

  const selectServerCb = encryptUser => {


    // Dialog.alert({
    //     content: `上号排队中....`,
    //     confirmText: '确认',
    //     // cancelText: '取消',
    //     lockScroll: false,
    //     hideCancelButton: true,
    //     closeOnOverlayClick: true
    // })


    getUser()
    // setPage(1)
    // setLoginType(3)
    // setUsers(users)
    // setCurrentUser(users.find(item => item.encrypt_user === encryptUser))
    // if (users.length === 1) {
    //   setShowTour(true)
    // }
  }

  const doDailyCb = () => {

    getUser()
    // setUsers(users)
    // user.config = currentUser.config
    // user.login_type = currentUser.login_type
    // user.server_id = currentUser.server_id
    // user.encrypt_user = currentUser.encrypt_user
    // user.card_type = currentUser.card_type
    // user.created_date = currentUser.created_date
    // users.forEach(item => {
    //   if (item.encrypt_user === user.encrypt_user) {
    //     for (let key in item) {
    //       item[key] = user[key]
    //     }
    //   }
    // })
    // setCurrentUser(user)
    // setUsers([...users])

  }


  return (
    <>

      {page >= 0 && <>
        <Cell title={"咸鱼之王"} extra={<div id="lock" onClick={() => {
          if (!['/8', '/88', '/888', '/8888', '/88888', '/888888', '/8888888', '/88888888', '/888888888', '/8888888888'].includes(pathname)) {
            setDialogStatus({ show: true })
          }
        }}>{password ? <Lock /> : <Unlock />}</div>} align="center" />
        <Tour
          className="nut-custom-tour nut-customword-tour"
          visible={showTour}
          onClose={closeTour}
          list={steps}
          type="tile"
          location="left-start"

        />
      </>}

      {page === -3 && <div>服务器更新中, 请明天再来</div>}
      {page === -4 && <div>还未获取到用户信息, 请五分钟后再打开</div>}

      {percent > 0 && percent < 100 &&
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999, width: 'calc(100% - 40px)' }}>
          <Animate type="breath" loop style={{ position: 'relative', left: 'calc(50% - 20px)', transform: 'translate(-50%, 0)', zIndex: 9999 }}>
            <Avatar src={阿咸} size="large" style={{ background: 'transparent' }} />
          </Animate>
          <Progress percent={percent} color="linear-gradient(270deg, rgba(18,126,255,1) 0%,rgba(32,147,255,1) 32.815625%,rgba(13,242,204,1) 100%)"
            animated style={{ marginTop: '10px' }} />
        </div>
      }


      {loading &&
        <Loading type="circular" style={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)', zIndex: 999999, height: '20px', width: '20px'
        }} />}

      {page === -2 && <NotFound />}
      {page === -1 && <Init setPercent={setPercent} loginType={loginType} serverList={serverList} selectServerCb={selectServerCb} user={currentUser} setLoading={setLoading} />}

      {page === 0 && <Book loginType={loginType} user={currentUser} />}
      {page === 1 && <Home loginType={loginType} user={currentUser} doDailyCb={doDailyCb} updateConfig={updateConfig} notice={notice} />}
      {page === 2 && <Setting loginType={loginType} user={currentUser}
        updateConfig={updateConfig}
        setPage={setPage}
        onConfigChangeCb={onConfigChangeCb}
        onCancelConfirmDialog={onCancelConfirmDialog}
        setConfirmDialog={setConfirmDialog}
        doDailyCb={doDailyCb}
      />}

      {page >= 0 &&
        <Tabbar fixed onSwitch={value => {
          if (page === 2 && formValues) {
            setConfirmDialog({
              show: true,
              // title: "确认",
              content: <div style={{ textAlign: 'center' }}>是否保存设置?</div>,
              onConfirm: () => {
                // setPage(value)
                updateConfig(formValues, () => setPage(value))
                onCancelConfirmDialog()
                setFormValues(null)
              },
              onCancel: () => {
                setPage(value)
                onCancelConfirmDialog()
                setFormValues(null)
              },
              hideConfirmButton: false,
              hideCancelButton: false,
            })
          } else {
            setPage(value)
          }



        }} value={page}>
          <Tabbar.Item title="统计" icon={<AgendaIcon width={18} height={18} />} />
          <Tabbar.Item title="我的" icon={<UserIcon width={18} height={18} />} />
          <Tabbar.Item title="设置" icon={<SettingIcon width={18} height={18} />} />
        </Tabbar>}

      <Dialog
        title={dialogStatus.type === "validate" ? "输入密码" : dialogStatus.type === "init" ? "设置密码" : "修改密码"}
        // content= {getQrImage()}
        confirmText='确认'
        cancelText='取消'
        hideConfirmButton={false}
        hideCancelButton={dialogStatus.type === "init" || dialogStatus.type === "validate" ? true : false}
        onConfirm={() => configPassword(dialogStatus.type)}
        onCancel={() => setDialogStatus({ show: false })}
        closeOnOverlayClick={false}
        visible={dialogStatus.show}>
        <>
          <NoticeBar content={`请妥善保管您的链接和密码, 不要泄露，一旦泄露及时修改`} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              background: '#fff',
              padding: '0 10px',
            }}
          >

            <Input type={inputType} placeholder="请输入密码" value={password}
              onChange={val => setPassword(val)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && password) {
                  configPassword(dialogStatus.type)
                }
              }} />
            <div
              className="right"
              onClick={() =>
                setInputType(inputType === 'text' ? 'password' : 'text')
              }
            >
              {inputType === 'text' ? (
                <Eye color="var(--nutui-gray-7)" />
              ) : (
                <Marshalling color="var(--nutui-gray-7)" />
              )}
            </div>
          </div>
        </>

      </Dialog>


      <Dialog
        title={confirmDialog.title}
        confirmText='确认'
        cancelText='取消'
        hideConfirmButton={confirmDialog.hideConfirmButton}
        hideCancelButton={confirmDialog.hideCancelButton}
        onConfirm={confirmDialog.onConfirm}
        onCancel={confirmDialog.onCancel ? confirmDialog.onCancel : onCancelConfirmDialog}
        closeOnOverlayClick={false}
        visible={confirmDialog.show}>
        {confirmDialog.content}
      </Dialog>

    </>
  );
}

export default App;
